module.exports = __webpack_public_path__ + "img/device.62fc3b5.webp";